// extracted by mini-css-extract-plugin
module.exports = {"i19bhwvs":"i19bhwvs","ed4ga4g":"ed4ga4g"};